import React, { useCallback, useRef } from 'react';

import { ScrollTrackingBlockData } from 'api/cms';
import { trackEvent } from 'utils/analytics';
import { useElementReachedEffect, useScrollEffect } from 'utils/screen';

type Props = {
  data: ScrollTrackingBlockData;
};

export function ScrollTrackingBlock({ data: { eventName } }: Props) {
  const scrolledRef = useRef(false);

  useScrollEffect(
    useCallback(() => {
      scrolledRef.current = true;
    }, []),
    { skipBootTrigger: true }
  );

  const ref = useRef<HTMLDivElement>(null);

  useElementReachedEffect({
    ref,
    onReach: useCallback(() => {
      const scrolled = scrolledRef.current;
      trackEvent(`Scroll: ${eventName}`, {
        reached_through: scrolled ? 'Scrolling' : 'Page Load',
      });
    }, [eventName]),
  });

  return <div ref={ref} />;
}
